import { Box, Image} from "@mantine/core";

const _SearchImageComponent = ({component}) => {
    return (

        <>
            <Box
                bg={component?.customize_styles?.general_decoration?.background_color}
                mx={component?.customize_styles?.general_decoration?.margin_x}
                my={component?.customize_styles?.general_decoration?.margin_y}
                px={component?.customize_styles?.general_decoration?.padding_x}
                py={component?.customize_styles?.general_decoration?.padding_y}
                style={{
                    boxShadow: `#00000014 ${component?.customize_styles?.general_decoration?.shadow_offset_x}px ${component?.customize_styles?.general_decoration?.shadow_offset_y}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px ${component?.customize_styles?.general_decoration?.shadow_blur_radius}px`,
                    borderRadius: `${component?.customize_styles?.general_decoration?.border_radius}px`,
                    border: `${component?.customize_styles?.general_decoration?.border_width}px solid ${component?.customize_styles?.general_decoration?.border_color}`,
                }}
            >
                <Image
                    src={component?.image_url}
                    fit="contain"
                    radius={component?.customize_styles?.image_decoration?.radius}
                />

            </Box>
        </>

    )
}
export default _SearchImageComponent;